"use client";

import { SkeletonLine, SkeletonPill } from "@health/ui";

/**
 * Loading skeleton mirroring WeightInput — accent-light card with date in
 * the top-left, tag pill in the top-right, and a large weight value with
 * unit label.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link WeightInputWidget} chunk.
 */
export function WeightInputWidgetSkeleton() {
  return (
    <div className="w-full max-w-lg">
      <div className="rounded-2xl bg-accent-light p-6">
        <div className="flex items-start justify-between mb-6">
          <SkeletonLine $size="text" $width="md" />
          <SkeletonPill $size="sm" $width="sm" />
        </div>
        <div className="flex items-baseline">
          <SkeletonLine $size="heading" $width="xs" className="h-14 w-32" />
          <SkeletonLine $size="text" $width="xs" className="ml-2 w-10" />
        </div>
      </div>
    </div>
  );
}
